import dex from "./dex"
import points from "./points"
import rebate from './rebate'
export default {
    home: {
        app: 'Memeshot',
        title: 'Memeshot.com , that\'s the meme.',
        subTitle: '밈 코인을 발굴하고 도전, 수익을 거두세요. 이것이 전부입니다',
        inviteFriends: '프로들과 함께하고 MEME 코인 ',
        inviteTextEnd: '배 수익을 잡아보세요!',
        appStore: 'App Store',
        testFlight: 'TestFlight',
        googlePlay: 'Google Play',
        android: 'Android',
        scanToDownload: '스캔 후 즉시 다운로드',
        soon: '곧 공개 예정',
        downloadFrom: '다운로드 경로',
        appDownload: 'APK 다운로드',
        joinUs: '가입하기',
        followUs: '팔로우하기',
        learn: '배우기',
    },
    referralCenter: {
        "inviteFriend": "초대 유저 수수료 30% 보너스, 지금 함께 시작하세요",
        "referralRules": "규칙",
        "totalReward": "내 총 보상",
        "usdtAmount": "$",
        "referralCount": "추천",
        "defaultReferral": "내 커미션 환급",
        "youReceive": "내 환급 비율",
        "receiveAmount": "50%",
        "referralLink": "추천 링크",
        "inviteButton": "지금 친구를 초대하세요!",
        "referralOverview": "추천 센터",
        "totalReferralIncome": "총 환급액($)",
        "totalReferralCount": "총 추천 수",
        "myInvitations": "내 초대 목록",
        "myRebates": "내 환급액",
        "userId": "사용자 ID",
        "rebateRate": "환급 비율",
        "registrationTime": "가입 시간",
        "releaseTime": "지급 시간",
        "rebateAmount": "환급액",
        "status": "상태",
        "pendingRelease": "미지급",
        "released": "지급 완료",
        "copied": "복사됨",
        "dataDetails": '세부 정보',
        "joinBtn": "전략적 제휴",
        "title1": "일반 커뮤니티 회원 (R)",
        "desc1": "R은 초대한 사용자들이 발생시킨 수수료의 10%를 받을 수 있습니다.",
        "title2": "골드 커뮤니티 리더 (G)",
        "desc2": "G은 초대한 사용자들이 발생시킨 수수료의 50%를 받을 수 있습니다.",
        "title3": "실버 커뮤니티 리더 (S)",
        "desc3": "S은 초대한 사용자들이 발생시킨 수수료의 40%를 받을 수 있습니다.",
        "invitation": "친구 초대",
        "pageTitle": "친구 초대",
        "pageSubtitle": "추천인이 발생시킨 수수료의 ** 보너스",
        "invitationRelationship": "관계",
        "rebateRatio": "커미션 비율",
        "inviterID": "초대자 ID",
        'hash': '해시',
        'prePage': '이전',
        'nextPage': '다음',
    },
    "referralRulesTexts": {
        "text0": "초대 등급:",
        "text1": "골드 커뮤니티 리더 (G)",
        "text2": "실버 커뮤니티 리더 (S)",
        "text3": "일반 커뮤니티 회원 (R)",
        "text4": "커미션 규칙:",
        "text5": "골드 커뮤니티 리더 (G):",
        "text6": "직접 초대한 실버 커뮤니티 리더 (S)로부터 거래 수수료 커미션의 40%를 획득합니다.",
        "text7": "직접 초대한 일반 커뮤니티 회원 (R)으로부터 거래 수수료 커미션의 50%를 획득합니다.",
        "text8": "간접적으로 초대한 일반 커뮤니티 회원 (R)으로부터 거래 수수료 커미션의 10%를 획득합니다.",
        "text9": "실버 커뮤니티 리더 (S):",
        "text10": "직접 초대한 일반 커뮤니티 회원 (R)으로부터 거래 수수료 커미션의 40%를 획득합니다.",
        "text11": "일반 커뮤니티 회원 (R):",
        "text12": "직접 초대한 다른 일반 커뮤니티 회원 (R)으로부터 거래 수수료 커미션의 10%를 획득합니다.",
        "text13": "역할 획득 방법:",
        "textRoleTitle1": "골드 커뮤니티 리더 (G):",
        "text14": "총 커미션 50,000달러를 달성하거나 '전략적 제휴'을 통해 이 역할을 신청하세요.",
        "textRoleTitle2": "실버 커뮤니티 리더 (S):",
        "text15": "총 커미션 30,000달러를 달성하거나 이 역할을 신청하세요, 또는골드 커뮤니티 리더 (G)가 공유한 초대 링크를 통해 등록하세요.",
        "textRole2Text": "",
        "textRoleTitle3": "일반 커뮤니티 회원 (R):",
        "text16": "직접 등록하거나, 또는골드 커뮤니티 리더 (G), 실버 커뮤니티 리더 (S), 또는 다른 일반 커뮤니티 회원 (R)의 초대를 받으세요.",
        "text17": "커미션 정산:",
        "text18": "커미션은 총액이 5달러에 도달하면 정산됩니다.",
    },
    register: {
        title: 'Memeshot 계정 생성',
        account: '계정',
        email: '이메일',
        accountPlaceholder: '이메일 입력',
        accountErrMsg: '유효하지 않은 이메일',
        password: '비밀번호',
        passwordPlaceholder: '비밀번호',
        passwordErrMsg: '비밀번호 입력 (소문자, 대문자, 숫자, 특수문자 중 최소 3종 포함)',
        passwordErrMsgOne: '8자 이상',
        passwordErrMsgTwo: '20자 이하',
        passwordErrMsgThree: '문자/숫자 포함 필수',
        signIn: '로그인',
        signUp: '회원가입',
        verifyBtn: '코드 받기',
        verify: '코드',
        verifyDesc: '인증 코드 입력',
        emailVerify: '이메일 인증 코드',
        emailVerifyPlaceholder: '인증 코드 입력',
        resend: '재전송',
        confirm: '확인',
        confirmPassword: '비밀번호 확인',
        confirmPasswordErr: '비밀번호 불일치',
        inviteCode: '초대 코드(선택)',
    },
    Cancellation: {
        logoffAccount: "계정 해지 신청",
        reason: '이유',
        reasonCancellation: "해지 사유",
        applyInTitle: " 검토 중, 감사합니다",
        applyDoneText: "해지 완료",
        cancelApplyButton: "신청 취소",
        submit: '제출',
        cancelApply: '신청 취소'
    },
    // 目前只支持英文版
    "userAgreement": {
        "welcome": "Thank you for using Memeshot!",
        "policyMainText": "This Privacy Policy details how we collect, use, disclose, and protect your personal information to ensure your privacy rights. We are committed to complying with data privacy laws and regulations and safeguarding the security of your personal information.",
        "part1": "1. Protection of Information",
        "part1Text": "In the course of using this application, we may protect information including but not limited to the following types:",
        "part1_1": "1.1 User Identity Information",
        "part1_1Text": "- Wallet Address: The blockchain wallet address you create or connect to this application. We do not collect your real identity information.",
        "part1_1Text2": "- Transaction Records: Necessary on-chain transaction records used to provide services, which do not include any unnecessary personal identification information.",
        "part1_2": "1.2 Usage Information",
        "part1_2Text": "- Application Usage Data: We automatically collect your interaction data with this application, such as page visits, clicks, and browsing behavior, to help us optimize application features and user experience.",
        "part1_3": "1.3 Device Information",
        "part1_3Text": "- Device Identifiers and Operating System: Includes the device's operating system version and unique device identifier, used to ensure the normal operation and security of the application.",
        "part2": "2. Use of Information",
        "part2Text": "We strictly use your information in a legal, proper, and necessary manner in accordance with this Privacy Policy and relevant laws and regulations. The specific purposes are as follows:",
        "part2_1": "- Providing and Maintaining Services: Processing on-chain transactions to ensure the normal operation of the custodial wallet.",
        "part2_2": "- Improving User Experience: Continuously optimizing product features and user interfaces by analyzing application usage behaviors.",
        "part2_3": "- Ensuring Security: Detecting, preventing, and resolving fraud and illegal activities to protect the security of your assets.",
        "part3": "3. Sharing of Information",
        "part3Text": "We do not sell, rent, or share your personal information with any third parties, but we may share your information under the following circumstances:",
        "part3_1": "Third-Party Service Providers: To provide application functionalities, we may need to share necessary information with trusted third-party partners. These third parties are limited to using your information only within the scope required to provide their services.",
        "part3_2": "Legal Requirements: Your information may need to be disclosed if required by laws, legal processes, or government requests.",
        "part4": "4. Security of Information",
        "part4Text": "We are committed to protecting the security of your personal information and have implemented reasonable technical and managerial measures to prevent unauthorized access, disclosure, alteration, or destruction of your information. However, the network environment is not 100% secure, so please properly safeguard your wallet keys and other sensitive information.",
        "part5": "5. Privacy Protection for Minors",
        "part5Text": "This application is not intended for minors. If we discover that we have collected personal information from minors, we will take steps to delete the relevant data as soon as possible.",
        "part6": "6. Your Rights",
        "part6Text": "Under applicable data protection laws, you have the right to perform the following actions regarding your information:",
        "part6_1": "Access, Update, and Deletion: You can access, update, or delete your account information.",
        "part6_2": "Privacy Settings: You can adjust your privacy settings within the application at any time to manage how your information is collected and used.",
        "part7": "7. Changes to the Privacy Policy",
        "part7Text": "We may update this Privacy Policy from time to time. The updated Privacy Policy will be posted on this page with the effective date indicated. We recommend that you regularly review the Privacy Policy to stay informed about our latest privacy protection measures.",
    },
    dex: dex.ko_KR,
    points: points.ko_KR,
    rebate: rebate.ko_KR,
}